/* eslint-disable indent,no-undef */
import * as types from 'store/mutation-types'
import api, { apiV2 } from 'store/api'
import Vue from 'vue'

const _isFalsy = val =>
    _.isNil(val) || _.isEmpty(val) || val == 0 || val === false

const _isValid = val => !_isFalsy(val)

const requestCancel = {
    token: Vue.axios.CancelToken,
    source: null
}

const state = {
    searchFilters: {
        agencies: [],
        date: null
    },

    addParams: {
        agencies: null,
        customer_id: null,
        offer_id: null
    },

    priceList: {},
    defaultPriceList: {},
    flag: null,
    hasActiveMailForwardingPackage: false,

    consumptions: [],
    customers: [],
    offers: [],
    uid: 0,
    requestCancel
}

const mutations = {
    [types.CONSUMPTIONS_RECEIVED](state, payload) {
        state.consumptions = payload
    },

    [types.FILTER_CHANGED](state, payload) {
        state.searchFilters = _.assign({}, state.searchFilters, payload)
        state.consumptions = []
    },

    [types.PARAMS_CHANGED](state, payload) {
        state.addParams = _.assign({}, state.addParams, payload)
    },

    [types.OFFERS_RECEIVED](state, payload) {
        state.offers = [].concat(payload)
    },

    [types.CUSTOMERS_RECEIVED](state, payload) {
        state.customers = payload
    },

    [types.AGENCY_CHANGED](state) {
        state.customers = []
        state.offers = []
        state.priceList = {}
        state.defaultPriceList = {}
        state.addParams.customer_id = null
        state.addParams.offer_id = null
        state.flag = null
        state.hasActiveMailForwardingPackage = false
    },

    [types.MAIL_FORWARDING_PACKAGE_CHECKED](state, value) {
        state.hasActiveMailForwardingPackage = value
    },

    [types.PRICE_LIST_CHOSEN](state, payload) {
        state.priceList = _.assign({}, payload)
        // state.sendData.price = state.priceList.base_price
        // state.sendData.quantity = state.priceList.base_quantity
    },

    [types.DEFAULT_PRICE_LIST_CHANGED](state, payload) {
        state.defaultPriceList = _.assign({}, payload)
    },

    [types.PRICE_LIST_FLAG](state, n) {
        state.flag = n
    },

    [types.UID_INCREMENTED](state) {
        state.uid++
    },

    [types.REQUEST_TOKEN_SOURCE_CHANGED](state, source) {
        state.requestCancel.source = source
    }
}

const actions = {
    fetchConsumptions({ commit, getters }) {
        // canceling any previous & pending AJAX query
        if (!_.isNull(state.requestCancel.source))
            state.requestCancel.source.cancel()

        const token = state.requestCancel.token,
            source = token.source(),
            cancelToken = source.token

        commit(types.REQUEST_TOKEN_SOURCE_CHANGED, source)
        return api.fetchConsumptions(getters.normalizedSearchFilters, cancelToken)
            .then(response => commit(types.CONSUMPTIONS_RECEIVED, response.data.consumptions))
    },

    addConsumption({ dispatch, state }, model) {
        const sendData = {
            // eslint-disable-next-line camelcase
            ...model,
            ...state.addParams
        }

        return api.addConsumption(sendData)
            .then(() => dispatch('fetchConsumptions'))
        // TODO: compare filters to determinate if refresh needed
    },

    updateFilters({ dispatch, commit }, filter) {
        commit(types.FILTER_CHANGED, filter)
        dispatch('fetchConsumptions')
    },

    fetchOffers({ commit, getters }) {
        const params = _.assign({
            distribution_methods: [6 /* , 4 */]
        },
            getters.normalizedAddParams
        )

        return api.fetchOffers(params)
            .then(response => commit(types.OFFERS_RECEIVED, response.data.offers))
    },

    fetchCustomers({ commit, getters }) {
        return apiV2.fetchCustomers(getters.normalizedAddParams)
            .then(response => commit(types.CUSTOMERS_RECEIVED, response.data.data))
    },

    updateAddParams({ commit }, params) {
        commit(types.PARAMS_CHANGED, params)
    },

    removeConsumption({ dispatch }, id) {
        return api.removeConsumption(id)
            .then(() => dispatch('fetchConsumptions'))
    },

    fetchAgencyBasedData({ dispatch, commit }) {
        commit(types.AGENCY_CHANGED)
        return Promise.all([
            dispatch('fetchOffers'),
            dispatch('fetchCustomers')
        ])
    },

    prepareSecondStep({ commit, state }) {
        const offer = _.find(state.offers, ['id', Number(state.addParams.offer_id)]),
            defaultPriceList = offer.default_price_list || [],
            _keys = Object.keys(defaultPriceList),
            len = _keys.length

        commit(types.PRICE_LIST_FLAG, len)
        commit(types.PRICE_LIST_CHOSEN, {})
        commit(types.DEFAULT_PRICE_LIST_CHANGED, defaultPriceList)

        if (len === 0) {
            const baseUnit = offer.sap_unit,
                priceList = {
                    unit_text: baseUnit.display_name,
                    unit: baseUnit.name,
                    base_quantity: 1
                }

            commit(types.PRICE_LIST_CHOSEN, priceList)
        } else if (len === 1) {
            commit(types.PRICE_LIST_CHOSEN, defaultPriceList[_keys[0]])
        }
        /* else {
         commit(types.DEFAULT_PRICE_LIST_CHANGED, defaultPriceList)
         } */
        commit(types.UID_INCREMENTED)
    },

    choosePriceList({ commit, state }, key) {
        commit(types.PRICE_LIST_CHOSEN, state.defaultPriceList[key])
    },

    fetchCustomerMailForwardingPackage({ commit }, customerId) {
        commit(types.MAIL_FORWARDING_PACKAGE_CHECKED, false)
        return apiV2.getCustomer(customerId)
            .then(response => commit(
                types.MAIL_FORWARDING_PACKAGE_CHECKED,
                response.data.data.attributes.has_active_mail_forwarding_package
            ))
    }

}

const getters = {
    userAgenciesIdList(state, getters, rootState) {
        return _.map(
            rootState.user.agencies,
            (agency) => String(agency.id)
        )
    },

    selectAgenciesList(state, getters, rootState) {
        return _.chain(rootState.agencies)
            // .filter(['archived', false])
            .filter(['disabled_for_tup', false])
            .map(
            (agency) => ({
                id: agency.id,
                text: agency.display_name
            })
            ).value()
    },

    selectDefaultPriceList(state) {
        return _.map(
            state.defaultPriceList,
            (price, key) => ({
                id: key,
                text: `${price.base_price} ${price.currency} ${price.unit_text}`
            })
        )
    },

    someConsumptions(state) {
        return !_.isEmpty(state.consumptions)
    },

    normalizedSearchFilters(state) {
        return _.pickBy(
            state.searchFilters,
            _isValid
        )
    },

    normalizedAddParams(state) {
        return _.chain(state.addParams)
            .pickBy(_isValid)
            .mapValues(
            (value, key) => key === 'agencies' ? Array(value) : value
            ).value()
    },

    firstStepIsNotValid(state) {
        return (
            _.isEmpty(state.addParams.agencies) || _.isEmpty(state.addParams.customer_id) || _.isEmpty(state.addParams.offer_id)
        )
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./client/store/modules/consumption.js